
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Chintamani Ganpati Temple Theur" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Chintamani Ganpati Temple Theur" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Chintamani Temple, Chintamani Ganpati Theur, Ashtavinayak Ganpati Theur, Chintamani Ganesh Temple Pune, Ashtavinayak Yatra Theur, Theur Ganpati Temple, Chintamani Vinayak Temple, Ashtavinayak Pilgrimage Theur, Chintamani Ganpati Maharashtra, Ashtavinayak Darshan Theur'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Chintamani Temple, Chintamani Ganpati Theur, Ashtavinayak Ganpati Theur, Chintamani Ganesh Temple Pune, Ashtavinayak Yatra Theur, Theur Ganpati Temple, Chintamani Vinayak Temple, Ashtavinayak Pilgrimage Theur, Chintamani Ganpati Maharashtra, Ashtavinayak Darshan Theur, chintamani temple, theur photos, chintamani ganpati location, theur ganpati distance, chintamani theur temple timings, theur ganpati temple, chintamani ganpati pune' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/chintamani.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/chintamani.webp'
          },
        ],
    }
},

    components: {
    },
    data() {
        return {
            title: 'Shree Chintamani Ganpati Temple Theur | Ashtavinayak - श्री चिंतामणी गणपती थेऊर(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/chintamani"
        },
        "headline": "Shree Chintamani Ganpati Temple Theur - श्री चिंतामणी गणपती थेऊर(अष्टविनायक)",
        "name" : "Shree Chintamani Ganpati Temple Theur - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Chintamani Ganpati Temple Theur' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/chintamani.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
